export function getUserTimezone(): string {
  return (window.global && window.global.user && window.global.user.timezone) || 'UTC';
}
